import * as models from "app/models/requireme";


export function sucursalToString(x: models.SucursalDTO) {
    return x.DescripcionSucursal;

}


// WEBPACK FOOTER //
// ./app/logic/sucursal.tsx